export const boardAdvocacyReviewTour = {
  key: "boardAdvocacyReview",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-advocacy-review-list"]',
      content: t("Tour_BoardAdvocacyReview_List"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-advocacy-review-approve"]',
      content: t("Tour_BoardAdvocacyReview_Approve"),
      placement: "right",
    },
    {
      target: '[data-tour="board-advocacy-review-comment"]',
      content: t("Tour_BoardAdvocacyReview_Comment"),
      placement: "top",
    },
    {
      target: '[data-tour="board-advocacy-review-versions"]',
      content: t("Tour_BoardAdvocacyReview_Versions"),
      placement: "bottom",
    },
  ],
};
